import PropTypes from 'prop-types';

// components
import PublicGridKpi from '../PublicPage/PublicGridKpi';
import PublicBlocker from '../PublicPage/PublicBlocker';
import Loader from '../../juristec-ui/core/Loader';

const TemplatePreview = ({
  dashState = {
    dashboardDoc: {},
    kpisLayout: {},
    kpiItemList: [],
    isLoading: false,
  },
  dashDoc = {},
}) => (
  <>
    {dashState.isLoading && <Loader />}
    {(!dashState.isLoading && !dashState.dashboardDoc) ? (
      <PublicBlocker reason="notFound" />
    ) : (
      <>
        <PublicGridKpi
          pageOrigin="template"
          kpiItemList={dashState.kpiItemList}
          dashboardDoc={dashDoc ?? dashState.dashboardDoc}
          kpisLayout={dashState.kpisLayout}
        />
      </>
    )}
  </>
);

TemplatePreview.propTypes = {
  dashState: PropTypes.shape({
    kpiItemList: PropTypes.arrayOf(PropTypes.shape({})),
    dashboardDoc: PropTypes.shape({}),
    kpisLayout: PropTypes.shape({}),
    isLoading: PropTypes.bool,
  }),
  dashDoc: PropTypes.shape({}),
};

export default TemplatePreview;
